import { render, staticRenderFns } from "./NombreComercial.vue?vue&type=template&id=24760f70&"
import script from "./NombreComercial.vue?vue&type=script&lang=ts&"
export * from "./NombreComercial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports